module.exports = __webpack_public_path__ + "static/img/menu_first2.42034db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_first2.png
// module id = H7pB
// module chunks = 160